// extracted by mini-css-extract-plugin
export default {"frame__wrapper":"Frame_frame__wrapper__h-Dsn"};